import * as React from 'react';
import { resolve } from 'inversify-react';
import { Card } from 'antd';

import { ToastNotifications } from 'src/core/ui/toast';

interface IState {
	hasError: boolean;
}

export default class ErrorBoundary extends React.Component<{}, IState> {
	public state: IState = { hasError: false };

	@resolve
	private toastService: ToastNotifications;

	public static getDerivedStateFromError(error: Error) {
		// Update state so the next render will show the fallback UI.
		return { hasError: true };
	}

	public componentDidCatch(error: Error, info: React.ErrorInfo) {
		console.log(error, info);
		this.toastService.showToast("Error", error.message, "error");
	}

	public render() {
		if (this.state.hasError) {
			// You can render any custom fallback UI
			return (
				<Card
					title="Error"
					style={{ width: '100%' }}
				>
					<h1 style={{ color: 'red' }}>Something went wrong.</h1>
				</Card>
			);
		}

		return this.props.children;
	}
}



// WEBPACK FOOTER //
// ./src/core/ui/error-boundary.tsx